export const isCreditType = (type = "") =>
  !!(type && ["rin", "credit", "credits"].includes(type.toLowerCase()));

export const isDeficitType = (type = "") =>
  !!(type && ["rvo", "deficit", "deficits"].includes(type.toLowerCase()));
